import api from '../api';

export default {
    async getDataModulesAndLesson(accessToken, id) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            const response = await api.get(`/portal/module/course/${id}`,  {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao carregar cursos do aluno:', error);
                throw error;
        }
    },

}

